module.exports = __webpack_public_path__ + "img/candidate-roxo.2ef9738c.png";